import React, { useState } from 'react';
import axios from 'axios';
import { motion } from 'framer-motion';
import './Contact.css';

const Contact = ({ apiUrl }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus('sending');

    try {
      const response = await axios.post(`${apiUrl}/contact`, formData);
      
      if (response.data.success) {
        setStatus('success');
        setFormData({ name: '', email: '', message: '' });
        setTimeout(() => setStatus(''), 5000);
      }
    } catch (error) {
      console.error('Error sending message:', error);
      setStatus('error');
      setTimeout(() => setStatus(''), 5000);
    } finally {
      setLoading(false);
    }
  };

  return (
    <section id="contact" className="contact-section">
      <div className="container">
        <motion.div 
          className="contact-wrapper"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2 className="section-title">Let's <span className="gradient-text">Get Started</span></h2>
          <p className="section-subtitle">
            We offer full-cycle technology solutions that streamline your digital transformation journey.
            With cutting-edge technical expertise, we simplify complex business challenges.
          </p>
          
          <form className="contact-form" onSubmit={handleSubmit}>
            <div className="form-group">
              <input
                type="text"
                name="name"
                placeholder="Your Name"
                value={formData.name}
                onChange={handleChange}
                required
                disabled={loading}
              />
            </div>
            
            <div className="form-group">
              <input
                type="email"
                name="email"
                placeholder="Your Email"
                value={formData.email}
                onChange={handleChange}
                required
                disabled={loading}
              />
            </div>
            
            <div className="form-group">
              <textarea
                name="message"
                placeholder="Tell us about your project"
                rows="5"
                value={formData.message}
                onChange={handleChange}
                required
                disabled={loading}
              ></textarea>
            </div>
            
            <button 
              type="submit" 
              className="submit-btn"
              disabled={loading}
            >
              {loading ? 'Sending...' : 'Send Message →'}
            </button>
            
            {status === 'success' && (
              <div className="success-message">
                ✓ Message sent successfully! We'll get back to you soon.
              </div>
            )}
            
            {status === 'error' && (
              <div className="error-message">
                ✗ Something went wrong. Please try again or email us directly.
              </div>
            )}
          </form>
          
          <div className="contact-info">
            <div className="info-item">
              <span>📧</span>
              <span>info@xcotech.site</span>
            </div>
            <div className="info-item">
              <span>📞</span>
              <span>+91 9631153161</span>
            </div>
            <div className="info-item">
              <span>📍</span>
              <span>New Ashok Nagar Delhi</span>
            </div>
             <div className="info-item">
              <span>📍</span>
              <span>Behind Govt Hospital Mohania Bihar</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default Contact;